import request from '../request'

export default {
  getTitulosProfesionales: function () {
    return request.get('titulo_profesional')
  }
}
